export const isEqual = <T>(a: T, b: T): boolean => {
  const stack: Array<[unknown, unknown]> = [[a, b]]

  while (stack.length) {
    const [x, y] = stack.pop()!

    if (x === y) continue

    if (
      !x ||
      !y ||
      typeof x !== 'object' ||
      typeof y !== 'object' ||
      Array.isArray(x) !== Array.isArray(y)
    ) {
      return false
    }

    const xKeys = Object.keys(x as object)
    const yKeys = Object.keys(y as object)

    if (xKeys.length !== yKeys.length) {
      return false
    }

    for (const key of xKeys) {
      if (!(key in (y as object))) {
        return false
      }
      stack.push([(x as never)[key], (y as never)[key]])
    }
  }

  return true
}
